import React from 'react';
import PropTypes from 'prop-types';
import {
  CardHeader,
  Col,
  Row,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminPageSectionIcon from './SectionIcon';

import { getSetting } from '../../../helpers/Settings';

const AdminPageSectionHeader = ({
  section,
  sectionIndex,
  sectionsCount,
  isClosed,
  handleDeleteSection,
  handleSwitchSection,
  handleMoveSection,
}) => {
  const intl = useIntl();

  return (
    <CardHeader>
      <Row>
        <Col>
          <AdminPageSectionIcon sectionId={section.section} />
          <strong>
            {
            (getSetting('cs1') && section.section === 'collections-grid') ?
              intl.formatMessage({ defaultMessage: 'Latest Coverage' }) :
              section.name
            }
          </strong>
        </Col>
        <Col className="right section-actions">
          <a
            id={`section-delete-${section.id}`}
            href="#delete"
            onClick={(e) => {
              e.preventDefault();
              handleDeleteSection(section.id);
            }}
          >
            <i className="far fa-trash" />
          </a>
          <UncontrolledTooltip fade={false} target={`section-delete-${section.id}`}>
            {intl.formatMessage({ defaultMessage: 'Delete section' })}
          </UncontrolledTooltip>
          <a
            id={`section-move-up-${section.id}`}
            href="#move-up"
            className={sectionIndex === 0 ? 'disabled' : ''}
            onClick={(e) => {
              e.preventDefault();
              handleMoveSection(sectionIndex, sectionIndex - 1);
            }}
          >
            <i className="far fa-arrow-up" />
          </a>
          <UncontrolledTooltip fade={false} target={`section-move-up-${section.id}`}>
            {intl.formatMessage({ defaultMessage: 'Move up' })}
          </UncontrolledTooltip>
          <a
            id={`section-move-down-${section.id}`}
            href="#move-down"
            className={sectionIndex >= sectionsCount - 1 ? 'disabled' : ''}
            onClick={(e) => {
              e.preventDefault();
              handleMoveSection(sectionIndex, sectionIndex + 1);
            }}
          >
            <i className="far fa-arrow-down" />
          </a>
          <UncontrolledTooltip fade={false} target={`section-move-down-${section.id}`}>
            {intl.formatMessage({ defaultMessage: 'Move down' })}
          </UncontrolledTooltip>
          <a
            id={`section-collapse-${section.id}`}
            href="#collapse"
            className="collapse-link"
            onClick={(e) => {
              e.preventDefault();
              handleSwitchSection(section.id);
            }}
          >
            {isClosed ? (
              <i className="far fa-chevron-down" />
            ) : (
              <i className="far fa-chevron-up" />
            )}
          </a>
          <UncontrolledTooltip fade={false} target={`section-collapse-${section.id}`}>
            {
              isClosed ?
                intl.formatMessage({ defaultMessage: 'Expand' }) :
                intl.formatMessage({ defaultMessage: 'Collapse' })
            }
          </UncontrolledTooltip>
        </Col>
      </Row>
    </CardHeader>
  );
};

AdminPageSectionHeader.propTypes = {
  section: PropTypes.object.isRequired,
  sectionIndex: PropTypes.number.isRequired,
  sectionsCount: PropTypes.number.isRequired,
  isClosed: PropTypes.bool.isRequired,
  handleDeleteSection: PropTypes.func.isRequired,
  handleSwitchSection: PropTypes.func.isRequired,
  handleMoveSection: PropTypes.func.isRequired,
};

export default AdminPageSectionHeader;
